import { render } from "./borderWidth.vue?vue&type=template&id=4bce3c6e"
import script from "./borderWidth.vue?vue&type=script&lang=js"
export * from "./borderWidth.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__